import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchWebsiteSettings, selectWebsiteSettings  } from './../../../redux/slices/settings/WebsiteSettingsSlice';
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay, Pagination } from "swiper/modules"; // Swiper modules
import "swiper/css/autoplay";
import "swiper/css/pagination";
import topbg from "./../../../assets/images/service/topbg.png";
import BubblesBackground from "../../../common/BubblesBackground";
import { useNavigate } from "react-router-dom";
import SectionTitle from "../../SectionTitle/SectionTitle";
import NotFound from "../../NotFoundService/NotFoundService";
// Import your service images
import service1 from "./../../../assets/images/service/service1.png";
import service2 from "./../../../assets/images/service/service2.png";
import service3 from "./../../../assets/images/service/service3.png";
import service4 from "./../../../assets/images/service/service4.png";
const ServiceSwiper = ({ t, direction,language }) => {
  const dispatch = useDispatch();
  const services = useSelector(selectWebsiteSettings);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(fetchWebsiteSettings(5)); 
  }, [dispatch, language]);

const servicesArray = Array.isArray(services) ? services : [];
 // Array of images
 const serviceImages = [service1, service2, service3, service4];
// Direction specific styles
const cardStyle = {
  maxWidth: { md: "312px", xs: "280px" },
  height: "354px",
  padding: direction === "ltr" ? "16px 0px 16px 16px" : "16px 16px 16px 0px",
  margin: "0 auto",
  borderRadius: "5px",
  position: "relative",
  boxShadow: "0px 4px 4px 0px #00000040",
  flexShrink: 0,
  "&:hover": {
    transform: "scale(1.1)",
    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
    transition: "all 0.3s ease-in-out",
    backgroundColor: "#12538B",
    color: "#fff",
    "& .card-title": { color: "#fff" },
    "& .card-content": { color: "#FFFCF2" },
    "& .service-image": {
      filter: "invert(100%) brightness(200%)",
      transition: "filter 0.3s ease",
    },
    "& .service-button": {
      color: "#fff",
      borderColor: "#fff",
      "&:hover": {
        backgroundColor: "#fff",
        color: "#12538B",
      },
    },
  },
};

const imageContainerStyle = {
  position: "absolute",
  top: 0,
  [direction === "ltr" ? "right" : "left"]: 0,
  width: "100px",
  height: "100px",
};

const imageStyle = {
  width: "100%",
  height: "100%",
  borderRadius: "8px",
  transform: direction === "ltr" ? "scaleX(-1)" : "none",  // Flip image if RTL

};

const serviceImageContainerStyle = {
  position: "absolute",
  top: "30px",
  [direction === "ltr" ? "left" : "right"]: 30,
  width: "60px",
  height: "60px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const serviceImageStyle = {
  width: "60px",
  height: "60px",
  objectFit: "cover",
};

const cardContentStyle = {
  textAlign: direction === "ltr" ? "left" : "right",
  paddingTop: "80px",
};

const cardTitleStyle = {
  fontWeight: "600",
  mb: "8px",
  fontSize: "20px",
  fontWeight: 400,
  pt: "16px",
  textAlign: direction === "ltr" ? "left" : "right",
};

const cardContentTextStyle = {
  color: "#646464",
  mb: "24px",
  fontSize: "14px",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  WebkitLineClamp: 5,  // Limits to 5 lines
  textOverflow: "ellipsis",
  whiteSpace: "normal",  // Ensures wrapping of text
  textAlign: direction === "ltr" ? "left" : "right",
};

const buttonStyle = {
  position: "absolute",
  bottom: "30px",
  [direction === "ltr" ? "left" : "right"]: "30px",
};

return (
  <Box
    sx={{
      padding: "40px 20px",

      textAlign: "center",
    }}
  >
    <Box data-aos="fade-down">
      <BubblesBackground top="-33px" right="auto" left={0} bottom="auto" />

      <SectionTitle
        title={t.Services}
        fontSize="32px"
        color="#12538B"
        fontWeight={700}
        lineHeight="35.73px"
        mb="16px"
        dataAos="fade-down"
      />
      <Typography sx={{ color: "rgba(100, 100, 100, 0.7)", mb: "29px", fontSize: "18px", lineHeight: "26.79px", fontWeight: 400 }}>
        {t.serviceintro}
      </Typography>
    </Box>

    <Box data-aos="zoom-in">
      <Swiper
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          0: { slidesPerView: 1 }, // Extra small
          600: { slidesPerView: 2 }, // Small
          960: { slidesPerView: 3 }, // Medium
          1280: { slidesPerView: 4 }, // Large
          1920: { slidesPerView: 5 }, // Extra large
        }}
        modules={[Autoplay, Pagination]}
      >
        {servicesArray.length > 0 ? (
          servicesArray.map((service, index) => (
            <SwiperSlide key={service.Id}>
              <Box
                sx={{
                  padding: "0 20px",
                  px: 2,
                  mb: 6,
                  justifyContent: { sm: "space-between", md: "center" },
                  mt: 4,
                }}
              >
                <Card sx={cardStyle}>
                  <Box sx={imageContainerStyle}>
                    <img
                      src={topbg}
                       loading="lazy"
                      alt={`${service.title} icon`}
                      style={imageStyle}
                    />
                  </Box>

                  <Box sx={serviceImageContainerStyle}>
                      <img
                        src={serviceImages[index % serviceImages.length]}  // Loop through images
                        alt={`${service.ValueAr} icon`}
                         loading="lazy"
                        className="service-image"
                        style={serviceImageStyle}
                      />
                    </Box>

                  <CardContent sx={cardContentStyle}>
                    <Typography className="card-title" sx={cardTitleStyle}>
                      {/* {service.title} */}
                      {language === 'Arabic' ? service?.ValueAr : service?.Value}

                    </Typography>
                    <Typography className="card-content" sx={cardContentTextStyle}>
                      {/* {service.description} */}
                      {language === 'Arabic' ? service?.DescriptionAr : service?.DescriptionEn}
                    </Typography>

                    <Box sx={buttonStyle}>
                      <Button
                        onClick={() => {
                          // Scroll to the top
                          window.scrollTo(0, 0);

                          // Navigate to the service page
                          navigate(`/service/${service.Id}`);
                        }}
                        variant="outlined"
                        className="service-button"
                        sx={{
                          color: "#12538B",
                          borderRadius: "5px",
                          borderColor: "#12538B",
                          "&:hover": {
                            borderColor: "#fff",
                            backgroundColor: "transparent",
                            color: "#fff",
                          },
                        }}
                      >
                        {t.more}
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            </SwiperSlide>
          ))
        ) : (
          <NotFound />
        )}
      </Swiper>
      <BubblesBackground top="auto" right="-20px" left="auto" bottom="-60px" />
    </Box>
  </Box>
);
};

export default ServiceSwiper;
